// src/journey/FillInTheBlanksInJourney.jsx
import React from "react";
import FillInTheBlanksJourneyView from "./FillintheblanksJourneyView";

function FillInTheBlanksInJourney({ questionsCount = 2, onComplete }) {
    return (
        <FillInTheBlanksJourneyView
            isJourney={true}
            gameLength={questionsCount}
            suppressBackground={true}
            onComplete={onComplete} // ✅ pass down
        />
    );
}

export default FillInTheBlanksInJourney;
